import { all, call } from "redux-saga/effects";

import watchAppSaga from "./app";

export function* maintenanceSaga() {
	yield all([
		call(watchAppSaga),
	]);
}
